Vue.component('button-popover', {
  props: ['options','labellang'],
  template: '<div id="bt-group-popover"  v-if="isActive">' +
              '<button v-if="buttonShowMinimize" id="minimize" @click="minimize()" :title="this.labellang.tooltipMinimizeSession"><i class="material-icons">&#xE909;</i></button>'+
              '<button v-if="buttonShowCloseSession" id="closeSession" @click="openClosePanel" :title="this.labellang.tooltipCloseSession"><i class="material-icons">&#xE5C9;</i></button>'+
              '<button v-if="buttonRestartSession" id="restartSession" @click="restartConvy" :title="this.labellang.tooltipRestartButton"><i class="material-icons" md-light>cached</i></button>'+
              '</div>' ,
  data: function() {
    return {
      isAllowClose:true,
      isAllowMinimize:true,
      isActive:false,
      buttonShowMinimize:true,
      buttonShowCloseSession:true,
      buttonRestartSession: false

    }
  },
  mounted:function(){
    var that = this;

    this.$parent.$on('onPopOver', function (val) {
      that.contentShow(val);
    });

    bus.$on('showRestartButton', function(val) {
      that.buttonRestartSession = true;
    })

    bus.$on('hideRestartButton', function(val) {
        that.buttonRestartSession = false;
    })

	},
  methods: {
    minimize:function(){
        this.$parent.sendMessageToParent({command: this.options.ExternalCommands.COLLAPSE});
    },
    contentShow:function(val){
      this.isActive = val;
    },
    openClosePanel:function(){
      bus.$emit("onShowPanelClosing", true);
    },
    restartConvy: function() {
      bus.$emit('onShowPanelRestarting', true);
		},
    // closeSession:function(){
    //     var that = this;
    //     this.options.internal.requestCloseReason = "customer";
    //     this.options.internal.requestCloseFromCustomer = true;
    //     this.$parent.closeSession();
    // }

  }


})
